import React, {
  PropsWithChildren,
  useEffect,
  useState,
} from 'react'

import { BeforeInstallPromptEvent } from '@app/types'

import { InstallAppContext } from '@app/context'

export const InstallAppProvider = ({
  children,
}: PropsWithChildren) => {
  const [ event, setEvent ] =
    useState<BeforeInstallPromptEvent | null>(null)

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: Event) => {
      const installEvent = e as BeforeInstallPromptEvent

      installEvent.preventDefault()

      setEvent(installEvent)
    }

    window.addEventListener(
      'beforeinstallprompt',
      handleBeforeInstallPrompt
    )

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      )
    }
  }, [])

  return (
    <InstallAppContext.Provider
      value={{
        event,
        setEvent,
      }}
    >
      {children}
    </InstallAppContext.Provider>
  )
}
